import { render, staticRenderFns } from "./merge-radish-dialog.vue?vue&type=template&id=64cd35fe&scoped=true&"
import script from "./merge-radish-dialog.vue?vue&type=script&lang=js&"
export * from "./merge-radish-dialog.vue?vue&type=script&lang=js&"
import style0 from "./merge-radish-dialog.vue?vue&type=style&index=0&id=64cd35fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd35fe",
  null
  
)

export default component.exports